module.exports = __webpack_public_path__ + "media/images/front/common/userIcon_premium-0ec2a9fa884457f426f687cbedb3b302.png";